module.exports = __webpack_public_path__ + "media/images/client/RentSearchApplication/start-illustration-c5bd50be691c9e9d501030df0f908785.svg";